export function getCssVariableValue(variableName) {
  return getComputedStyle(document.documentElement).getPropertyValue(
    variableName,
  );
}

export function getLightOrangeDataEditorColor() {
  return "#d04a0251";
}
